import React from 'react';
// import i18n from 'utils/i18n';
import { Range as RRange } from 'react-range';

// loading the sass style fot the component
import css from './styles.module.scss';

const COLORS = ['#ff0000', '#555555', '#0000ff']; // TODO: add more colors
const Direction = {
  Right: 'to right',
  Left: 'to left',
  Down: 'to bottom',
  Up: 'to top'
};
/**
 * Atom Range
 * 
 * A range input to be used by itself or by InputControl.
 */
function Range (props) {
  // const gt = i18n.useTranslations('global');
  // const t = i18n.useTranslations('components.range');
  const DEFAULT_MIN = 0;
  const DEFAULT_MAX = 100;

  const {
    className = "",
    children,
    min,
    max,
    step,
    rtl,
    value = [],
    name,
    onChange,
    from,
    to,
    // reverseLast = false,
    colors = COLORS,
    labelPrefix = '',
    labelSufix = '',
    labelFrom,
    labelTo,
    hideValues = false,
    legend = null,
    valuesMap = null,
    legendsMap = null,
    disabled,
    ...other
  } = props;

  function getMin (m) {
    if (from === undefined) {
      let ret = m === undefined ? min : m;
      return ret === undefined ? DEFAULT_MIN : ret;
    }
    return from;
  }

  function getMax (m) {
    if (to === undefined) {
      let ret = m === undefined ? max : m;
      return ret === undefined ? DEFAULT_MAX : ret;
    }
    return to;
  }

  function getTrackBackground({
    values,
    colors,
    // min,
    // max,
    direction = Direction.Right,
    rtl = false
  }) {
    if (rtl && direction === Direction.Right) {
      direction = Direction.Left;
    } else if (rtl && Direction.Left) {
      direction = Direction.Right;
    }

    // sort values ascending
    const progress = getValue()
      .slice(0)
      .sort((a, b) => a - b)
      .map(value => getPerc(value));

    const middle = progress.reduce(
      (acc, point, index) =>
        `${acc}, ${colors[index]} ${point}%, ${colors[index + 1]}55 ${point}%`,
      ''
    );

    const str = `linear-gradient(${direction}, ${colors[0]}55 0%${middle}, ${colors[colors.length - 1]} 100%)`;
    return str;
  }

  function getValue (v) {
    v = v || value;
    if (v === '' || v?.length === 0) {
      v = 0;
    }

    const valueToUse = Array.isArray(v) ? v : [v];
    if (valueToUse[0] < min) {
      valueToUse[0] = min;
    }
    if (valueToUse[valueToUse.length - 1] > max) {
      valueToUse[valueToUse.length - 1] = max;
    }

    return valueToUse || [0];
  }

  function getPerc (value) {
    return ((value - getMin()) / (getMax() - getMin())) * 100;
  }

  if (other.values) {
    delete other.values;
  }

  return <div
    className={`${css["atom__range-container"]} ${className}`}
    data-disabled={disabled ? 1 : null}
    {...other}
  >
    <RRange
      step={step || 1}
      min={getMin() } //from === undefined ? min: from}
      max={getMax() } //to === undefined ? max: to}
      rtl={rtl}
      name={name}
      disabled={disabled}
      values={getValue() || []}
      onChange={(values) => {
        const value = getValue(values);
        const target = {
          name,
          value: value.length > 1 ? value : value[0]
        };
        onChange({target}, target);
      }}
      renderTrack={({ props, children }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: '.4rem',
            width: '100%',
            backgroundColor: '#555'
          }}
        >
          <div
            ref={props.ref}
            style={{
              height: '100%',
              width: '100%',
              borderRadius: '4px',
              background: getTrackBackground({
                values: getValue(),
                colors,
                min: min || 0, // from === undefined ? min: from,
                max: max || 100,// to === undefined ? max: to,
                rtl
              }),
              alignSelf: 'center'
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={(data) => {
        const { index, props, value, isDragged } = data;
        let theValue = step < 1
          ? getValue()[index].toFixed(1)
          : Math.round(getValue()[index]);

        const left = `calc(${getPerc(value)}% - 1rem)`;

        return (
          <div
            {...props}
            style={{
              ...props.style,
              height: '2rem',
              width: '2rem',
              top: "-.8rem",
              left: left,
              borderRadius: '4px',
              backgroundColor: '#FFF',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0px 2px 6px #AAA',
              transform: isDragged ? 'scale(1.2)': 'none'
            }}
          >
            {
              !hideValues && (
                <div
                  style={{
                    position: 'absolute',
                    top: '-2.5rem',
                    // color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    padding: '0 5px',
                    whiteSpace: 'nowrap',
                    borderRadius: '4px',
                    color: colors[index],
                    // backgroundColor: colors[index]
                  }}
                >
                  {labelPrefix}
                  {
                    valuesMap?.[theValue] || theValue
                  }
                  {labelSufix}
                </div>
              )
            }
            <div
              style={{
                height: '.8rem',
                width: '5px',
                backgroundColor: isDragged ? '#548BF4' : '#CCC'
              }}
            />
          </div>
        );
      }}
      // {...other}
    />
    <div className={css['bellow']}>
      {
        labelFrom && <label className={css['from']}>{labelFrom}</label>
      }
      {
        // legendsMap
      }
      {
        ((children && children.length) || legend || legendsMap) && (
          <label className={css['children']}>
            {
              children || legendsMap?.[getValue()[0]] || legend
            }
          </label>
        )
      }
      {
        labelTo && <label className={css['to']}>{labelTo}</label>
      }
    </div>
  </div>;
}

export default Range;
